import React, { FC, useEffect, useMemo, useState } from "react";
import { Message, SessionQuery } from "./types";
import { Document, Image, Page, StyleSheet, usePDF } from "@react-pdf/renderer";
import Logo from "../../../../../../images/icons/logo.png";
import { useSnapshot } from "valtio";
import { userDataStore } from "../../../../../../store/userData";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import VoiceMessageDisplay from "./VoiceMessageDisplay";
import AnalyticsModal from "./AnalyticsModal";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "white",
    // margin: 10,
  },
});

interface Props {
  messages: Message[];
  fibiClientToken?: string; //should be present for business
  sessionTemp: string;
  onInterviewOff: () => void;
}

const SessionEnded: FC<Props> = ({
  messages,
  fibiClientToken,
  sessionTemp,
  onInterviewOff,
}) => {
  const doc = useMemo(
    () => (
      <Document>
        <Page size="A4" style={styles.page}>
          <Image
            style={{
              width: "170px",
              height: "35px",
              margin: "auto",
              marginBottom: "40px",
            }}
            src={Logo}
          />
          {messages && <VoiceMessageDisplay messages={messages} />}
        </Page>
      </Document>
    ),
    [messages]
  );

  const [instance, updateInstance] = usePDF({
    document: doc,
  });

  useEffect(() => {
    updateInstance(doc);
  }, [doc, updateInstance]);

  const [searchParams, setSearchParams] = useSearchParams();
  const { userData } = useSnapshot(userDataStore);
  const [maxSessionCount, setMaxSessionCount] = useState<number>(0);
  const [open, setOpen] = useState(true);

  const onOpen = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (userData) setMaxSessionCount(userData.maxSessionCount as number);
  }, [userData]);

  const onStartNewSession = () => {
    if (Number(sessionTemp) >= maxSessionCount) {
      toast.error(
        "You either have an active session or have reached the maximum number of allowed sessions"
      );

      return;
    }

    searchParams.set(SessionQuery.sessionCount, `${Number(sessionTemp) + 1}`);
    setSearchParams(searchParams);
    onInterviewOff();
  };

  return (
    <>
      <div className="flex flex-col items-center gap-4">
        <div className="flex items-center gap-2 ">
          This session has ended.{" "}
          <button
            className="text-[#0076E9] border border-[#0076E9] py-2 px-6 bg-white rounded-xl hover:border-white transition-all"
            onClick={onOpen}
          >
            Review My Session
          </button>
        </div>
        <div
          role="button"
          onClick={onStartNewSession}
          className="w-3/5 p-4 text-center text-white duration-150 bg-[#0076e9] mmx-auto rounded-xl hover:bg-[#022e58]"
        >
          Start a New Session
        </div>
      </div>

      {open && (
        <AnalyticsModal
          onClose={onClose}
          downloadUrl={instance.url || ""}
          sessionTemp={sessionTemp}
          fibiClientToken={fibiClientToken}
          onStartNewSession={onStartNewSession}
        />
      )}
    </>
  );
};

export default SessionEnded;
